module.exports = __webpack_public_path__ + "images/emoji/busts_in_silhouette.5f44f983a87a5542ccbd.png";